import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
const All = (props) => (
  <SvgIcon {...props}>
    <g id="Icon/Product/Globe" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Globe" transform="translate(2.000000, 2.000000)" stroke={props.color} strokeWidth="1.5">
        <path d="M10,0 L10,20" id="Path-34"></path>
        <path d="M0,10 L20,10" id="Path-35"></path>
        <circle id="Oval-17" cx="10" cy="10" r="10"></circle>
        <path d="M9,0 C6.33333333,2.72645079 5,6.05978413 5,10 C5,13.9402159 6.33333333,17.2735492 9,20" id="Path-34"></path>
        <path d="M15,0 C12.3333333,2.72645079 11,6.05978413 11,10 C11,13.9402159 12.3333333,17.2735492 15,20" id="Path-34" transform="translate(13.000000, 10.000000) scale(-1, 1) translate(-13.000000, -10.000000) "></path>
        <path d="M2,5 L18,5" id="Path-35"></path>
        <path d="M2,15 L18,15" id="Path-35"></path>
      </g>
    </g>
  </SvgIcon>
);

export default All;



// WEBPACK FOOTER //
// ./src/icons/types/All.jsx